module.exports = __webpack_public_path__ + "static/images/licenseTemplate.e089ef6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/haoLian/licenseTemplate.png
// module id = 5E4s
// module chunks = 0